import Identity from "./Identity"
import IdentityCard from "./IdentityCard"

import UpdateIdentityEmailLink from "./UpdateIdentityEmailLink"
import TwoFactorAuthenticationModal from "./TwoFactorAuthenticationModal"
import TwoFactorAuthenticationSwitch from "./TwoFactorAuthenticationSwitch"

export default Identity

export {
  IdentityCard,
  UpdateIdentityEmailLink,
  TwoFactorAuthenticationModal,
  TwoFactorAuthenticationSwitch,
}
